import { FC, useEffect, useState } from 'react';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { BasicProps, navLinkType } from '../../types';
import NavigationLink from '../NavigationLink/NavigationLink';
import styles from './BurgerMenu.module.scss';
import ModalBackdrop from '../ModalBackdrop/ModalBackdrop';
import useMountTransition from '../../hooks/useMountTransition';

interface BurgerMenuProps extends BasicProps {
  links: navLinkType[];
}

const BurgerMenu: FC<BurgerMenuProps> = (props) => {
  const { links } = props;

  const [isVisible, setIsVisible] = useState(false);
  const transitionEnd = useMountTransition(isVisible, 400);

  useEffect(() => {
    console.log('visible: ' + isVisible);
    console.log('transitionEnd: ' + transitionEnd);
  }, [isVisible, transitionEnd]);

  const getMenu = () => {
    return ReactDOM.createPortal(
      <div
        className={classNames(styles.menuContainer, styles.hide, {
          [styles.visible]: isVisible && transitionEnd,
        })}
      >
        <div className={styles.header}>
          <div className={styles.closeContainer} onClick={() => setIsVisible(false)}>
            <FiX />
          </div>
        </div>
        {links.map((item) => (
          <NavigationLink key={item.to} to={item.to}>
            {item.label}
          </NavigationLink>
        ))}
      </div>,
      document.getElementById('overlay-root') as HTMLElement,
    );
  };

  return (
    <>
      <div className={styles.burgerButton} onClick={() => setIsVisible(true)}>
        <FiMenu />
      </div>
      {(transitionEnd || isVisible) && (
        <>
          <ModalBackdrop isVisible={isVisible && transitionEnd} onClick={() => setIsVisible(false)} />
          {getMenu()}
        </>
      )}
    </>
  );
};

export default BurgerMenu;
